<template>
  <div class="hero">
    <div class="container">
      <h3>Blogs en nieuws</h3>
      <h1>Laatste blogs en nieuws</h1>
      <p>Hieronder leest u de laatste blogs en nieuws</p>
      <div class="blog-container">
        <div class="blog-item">
          <div class="image">
            <img
              src="../assets/img/blog-images/anders-denken.png"
              alt=""
            >
          </div>
          <div class="content">
            <div class="blog-title">
              <h3>Anders denken, Anders doen!</h3>
            </div>
            <div class="blog-short-desc">
              <p>
                Anders denken, Anders doen! Geregeld wordt aan mij gevraagd wat
                eigenlijk het verschil is tussen het plannen met een digitaal
                planbord en plannen met Roosterplatform. Als ik deze vraag
                krijg...
              </p>
              <router-link
                to="/anders-denken-anders-doen"
                class="button secondary-button"
                tag="button"
              >
                lees meer
              </router-link>
            </div>
          </div>
        </div>
        <div class="blog-item">
          <div class="image">
            <img
              src="../assets/img/blog-images/geld.png"
              alt=""
            >
          </div>
          <div class="content">
            <div class="blog-title">
              <h3>Een efficiënte planning levert geld op!</h3>
            </div>
            <div class="blog-short-desc">
              <p>
                Vraag eens aan een manager uit de logistieke branche wat het
                oplevert als hij iets efficiënter zou omgaan met zijn resources.
                Zijn antwoord zal zijn, ‘het optimaliseren van processen is
              </p>
              <router-link
                to="/een-efficiënte-planning-levert-geld-op"
                class="button secondary-button"
                tag="button"
              >
                lees meer
              </router-link>
            </div>
          </div>
        </div>
        <div class="blog-item">
          <div class="image">
            <img
              src="../assets/img/blog-images/msr-grz.png"
              alt=""
            >
          </div>
          <div class="content">
            <div class="blog-title">
              <h3>De MSR en de GRZ zijn gewoon gelijk!</h3>
            </div>
            <div class="blog-short-desc">
              <p>
                Roosterplatform heeft bij meerdere Medisch Specialistische
                Revalidatiecentra (MSR) de planprocessen geanalyseerd. Bij Merem
                heeft Roosterplatform daadwerkelijk kunnen schaduw draaien en
                daarmee onderzocht of de software geschikt is voor de MSR.
              </p>
              <router-link
                to="/de-MSR-en-de-GRZ-zijn-gewoon-gelijk"
                class="button secondary-button"
                tag="button"
              >
                lees meer
              </router-link>
            </div>
          </div>
        </div>

        <div class="blog-item">
          <div class="image">
            <img
              src="../assets/img/blog-images/schaakcomputer.png"
              alt=""
            >
          </div>
          <div class="content">
            <div class="blog-title">
              <h3>De MSR en de GRZ zijn gewoon gelijk!</h3>
            </div>
            <div class="blog-short-desc">
              <p>
                Roosterplatform heeft bij meerdere Medisch Specialistische
                Revalidatiecentra (MSR) de planprocessen geanalyseerd. Bij Merem
                heeft Roosterplatform daadwerkelijk kunnen schaduw draaien en
                daarmee onderzocht of de software geschikt is voor de MSR.
              </p>
              <router-link
                to="/wat-als-de-schaakcomputer-de-behandeling-gaat-inplannen"
                class="button secondary-button"
                tag="button"
              >
                lees meer
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Blog",

  mounted() {},

  metaInfo() {
    return {
      title: "Roosterplatform - Blog",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

.hero {
  padding: 100px 0 200px;
  position: relative;
  z-index: 1;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
}

.blog-item {
  display: flex;
  gap: 20px;
  margin-bottom: 70px;
  .image {
    width: 300px;
    min-width: 300px;
    max-width: 300px;

    img {
      border-radius: 8px;
      margin-block: 16px;
      width: 100%;
      margin: 0;
    }
  }
  h3 {
    opacity: 1;
  }

  .blog-short-desc {
    p {
      display: -webkit-box;
      max-width: 100%;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
  .blog-item {
    display: block;
    .image {
      width: 100%;
      min-width: 100%;
      max-width: 100%;

      img {
        width: 100%;
        margin-block: 10px;
      }
    }
  }
}
</style>
